module.exports = __webpack_public_path__ + "img/PurchaseNewLicense.e6fffaba.jpg";